import request from '@/api/request'


//面试宝人员列表
export function auditList(data) {
    return request({
        url: '/web/enroll/audit/list',
        method: 'GET',
        params: data
    })
}


//面试宝人员列表
export function waitlist(data) {
    return request({
        url: '/web/enroll/audit/waitlist',
        method: 'GET',
        params: data
    })
}


//PC工作台-面试邀请等待/面试
export function updateAuditStatus(data) {
    return request({
        url: '/web/enroll/audit/status/update',
        method: 'POST',
        data
    })
}



//PC工作台-面试通过/备选/淘汰
export function updateAudit(data) {
    return request({
        url: '/web/enroll/audit/update',
        method: 'POST',
        data
    })
}


//PC工作台-面试宝导入人员
export function importAudit(data) {
    return request({
        url: '/web/enroll/audit/leading',
        method: 'POST',
        data
    })
}

//导入手机号
export function importMobile(data) {
    return request({
        url: '/web/enroll/audit/mobile/leading',
        method: 'POST',
        data
    })
}


//二维码邀请


export function importCode(data) {
    return request({
        url: '/web/enroll/audit/code/leading',
        method: 'POST',
        data
    })
}


//PC工作台-面试包面试结果
export function auditResult(data) {
    return request({
        url: '/web/enroll/audit/complete',
        method: 'GET',
        params: data
    })
}




//地址审核列表  查询面试信息
 //http://www.jianzhibei.local/api/purview/interview/getInterview?limit=10&page=1&project_id=&status=&interview_id=111&type=1
export function getInterview(data) {
    return request({
        url: '/api/purview/interview/getInterview',
        method: 'GET',
        params: data
    })
}

//修改面试邀请状态
//http://www.jianzhibei.local/api/purview/interview/upInterviewStatus
export function upInterviewStatus(data) {
    return request({
        url: '/api/purview/interview/upInterviewStatus',
        method: 'POST',
        data
    })
}




